import { useStore } from 'effector-react';
import { $compareState } from '../compareStores';
import type { CompareMode } from '../types';

interface EmptyTipProps {
  mode: CompareMode;
}

export function EmptyTip({ mode }: EmptyTipProps) {
  const { left, top } = useStore($compareState);
  if (mode === 'overlap') return null;
  return (
    <div
      className="pointer-events-none absolute inset-0 flex select-none items-center justify-center text-[#9E9E9E]"
      style={{
        ...((mode === 'horizontal' || mode === 'split') && {
          left: `${left * 100}%`,
        }),
        ...(mode === 'vertical' && {
          top: `${top * 100}%`,
        }),
      }}
    >
      还未选择对比场景
    </div>
  );
}
